"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceRenderer = exports.DateCreatedRenderer = exports.ViewBtnRenderer = exports.StatusRenderer = exports.ProgressRenderer = exports.DeadlineRenderer = exports.ReviewerRenderer = exports.ProjectRenderer = exports.ReviewRenderer = void 0;
const pulse_components_1 = require("@pcs/pulse-components");
const react_1 = __importDefault(require("@tippyjs/react"));
const clsx_1 = __importDefault(require("clsx"));
const utilities_1 = __importStar(require("jsAssets/utilities"));
const react_2 = __importStar(require("react"));
const client_1 = require("react-dom/client");
const react_redux_1 = require("react-redux");
const format_1 = __importDefault(require("date-fns/format"));
const get_1 = __importDefault(require("lodash/get"));
const material_1 = require("@mui/material");
const sliceReview_1 = require("../../../reviews-modal/slice/sliceReview");
const constants_1 = require("../../../reviews-modal/slice/sliceReview/constants");
const review_stages_1 = require("../../constants/review-stages");
const helper_1 = require("../../helper");
const CancelReviewModal_1 = __importDefault(require("../CancelReviewModal"));
const ReviewModalContext_1 = require("../ReviewModalContext");
const ReviewStagesDetail_1 = require("../ReviewStagesDetail");
const ViewLinkedTasksModal_1 = __importDefault(require("../ViewLinkedTasksModal"));
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const withMoveReviewModal_1 = __importDefault(require("../../HOC/withMoveReviewModal"));
const withPublicLinkModal_1 = __importDefault(require("../../HOC/withPublicLinkModal"));
const PulseAssetDetail = react_2.default.lazy(() => Promise.resolve().then(() => __importStar(require('../../../asset-detail'))));
const ManageNotificationsModal = react_2.default.lazy(() => Promise.resolve().then(() => __importStar(require('../ManageNotificationsModal'))));
const IS_VIEW_REVIEW = helper_1.VIEW_REVIEW_PERMISSION === 'y';
const IS_REVIEW_ADMIN = helper_1.REVIEWS_ADMIN_PERMISSION === 'y';
const CONTENT = helper_1.REQUEST.content || '';
const ROUND_STATUSES = [
    {
        value: 'uploading',
        label: 'uploading',
    },
    {
        value: 'in-progress',
        label: 'in progress',
    },
    {
        value: 'processing',
        label: 'processing',
    },
    {
        value: 'completed',
        label: 'completed',
    },
    {
        value: 'view_only',
        label: 'view only',
    },
    {
        value: 'failed',
        label: 'failed',
    },
];
const ROUND_STATUS_COLOR = {
    'in progress': '#2660B7',
    approved: '#288528',
    'approved with changes': '#288528',
    'changes required': '#B75F25',
    'not relevant': '#626166',
};
const ReviewRenderer = (props) => {
    const { record } = props;
    return (react_2.default.createElement("div", { className: styles_modules_less_1.default['custom-col-review__ellipsis'] },
        react_2.default.createElement(react_1.default, { content: `${record}`, placement: "top", maxWidth: '100%' },
            react_2.default.createElement("div", { className: styles_modules_less_1.default['custom-col-review__ellipsis--text'] }, `${record}`))));
};
exports.ReviewRenderer = ReviewRenderer;
const ProjectRenderer = (props) => {
    const { record } = props;
    return (react_2.default.createElement(react_1.default, { content: `${record}`, placement: "top", maxWidth: '100%' },
        react_2.default.createElement("div", { className: styles_modules_less_1.default['custom-col-project__ellipsis'] }, `${record}`)));
};
exports.ProjectRenderer = ProjectRenderer;
const ReviewerRenderer = (props) => {
    var _a, _b;
    const { record, widthColumn } = props;
    /**
     * 16px is the 24px (img width)
     */
    const maxReviewers = Math.floor(widthColumn / 24);
    return (react_2.default.createElement(material_1.AvatarGroup, { total: (_a = record === null || record === void 0 ? void 0 : record.reviewers) === null || _a === void 0 ? void 0 : _a.length, 
        // the max should be dynamic when resize column, will handle in the future
        max: maxReviewers, spacing: 0, slotProps: {
            additionalAvatar: {
                sx: {
                    zIndex: (_b = record === null || record === void 0 ? void 0 : record.reviewers) === null || _b === void 0 ? void 0 : _b.length,
                    height: 24,
                    width: 24,
                    border: '1px solid #fff',
                    background: '#E4E4E6',
                    color: '#313033',
                    fontSize: 12,
                },
            },
        } }, record === null || record === void 0 ? void 0 : record.reviewers.map((reviewer, index) => {
        return (react_2.default.createElement(react_1.default, { content: reviewer === null || reviewer === void 0 ? void 0 : reviewer.name, placement: "top", key: reviewer === null || reviewer === void 0 ? void 0 : reviewer.id },
            react_2.default.createElement(material_1.Avatar, { sx: {
                    zIndex: index,
                }, alt: reviewer === null || reviewer === void 0 ? void 0 : reviewer.name, src: reviewer === null || reviewer === void 0 ? void 0 : reviewer.avatar_url, classes: {
                    root: styles_modules_less_1.default['custom-col-reviewer__avatar'],
                }, imgProps: {
                    loading: 'eager',
                } })));
    })));
};
exports.ReviewerRenderer = ReviewerRenderer;
const DeadlineRenderer = (props) => {
    const { deadline } = props === null || props === void 0 ? void 0 : props.record;
    const deadlineColor = (0, helper_1.deadlineColorChange)(deadline);
    const parseDate = deadline
        ? (0, format_1.default)(new Date(deadline), (0, utilities_1.dateFormatBasedOnCountry)())
        : undefined;
    return (react_2.default.createElement(react_1.default, { content: deadline ? parseDate : 'NOT SET', placement: "top", key: deadline },
        react_2.default.createElement("span", { style: { color: deadlineColor, fontSize: 12, lineHeight: 16 } }, deadline ? parseDate : 'NOT SET')));
};
exports.DeadlineRenderer = DeadlineRenderer;
const ProgressRenderer = (props) => {
    const { record } = props;
    const data = record.progress;
    const stageStatus = record.status;
    return (react_2.default.createElement(pulse_components_1.PulseStatusProgress, { progress: stageStatus !== review_stages_1.STAGE_STATUS.notStarted ? data : ReviewStagesDetail_1.DEFAULT_PROGRESS, designVariant: "v3", view: "review", classes: {
            root: styles_modules_less_1.default.progressStatusRoot,
            active: styles_modules_less_1.default.progressStatusRoot__active,
        } }));
};
exports.ProgressRenderer = ProgressRenderer;
const StatusRenderer = (props) => {
    var _a;
    const { record } = props;
    if (record.decision_status_label) {
        const colorDecisionStatus = (0, get_1.default)(ROUND_STATUS_COLOR, (_a = record.decision_status_label) === null || _a === void 0 ? void 0 : _a.toLowerCase(), null);
        const colorProp = {
            ...(colorDecisionStatus && { color: colorDecisionStatus }),
        };
        return (react_2.default.createElement(pulse_components_1.PulseChip, { ...colorProp, label: record.decision_status_label, classes: {
                root: styles_modules_less_1.default['review-status-chip-cell__body'],
                label: styles_modules_less_1.default['review-status-chip-cell__label'],
            }, PulseTooltipProps: {
                TippyProps: {
                    visible: false,
                },
            } }));
    }
    return (react_2.default.createElement("div", { className: styles_modules_less_1.default['pulse-review-status-rows'] }, ROUND_STATUSES.map((roundStatus) => {
        var _a;
        const color = (0, get_1.default)(ROUND_STATUS_COLOR, (_a = roundStatus === null || roundStatus === void 0 ? void 0 : roundStatus.label) === null || _a === void 0 ? void 0 : _a.toLowerCase(), null);
        const colorProp = {
            ...(color && { color }),
        };
        return ((record === null || record === void 0 ? void 0 : record.round_status) === (roundStatus === null || roundStatus === void 0 ? void 0 : roundStatus.value) && (react_2.default.createElement(pulse_components_1.PulseChip, { ...colorProp, classes: {
                root: styles_modules_less_1.default['review-status-chip-cell__body'],
                label: styles_modules_less_1.default['review-status-chip-cell__label'],
            }, key: roundStatus === null || roundStatus === void 0 ? void 0 : roundStatus.value, label: roundStatus === null || roundStatus === void 0 ? void 0 : roundStatus.label, PulseTooltipProps: {
                TippyProps: {
                    visible: false,
                },
            } })));
    })));
};
exports.StatusRenderer = StatusRenderer;
const DateCreatedRenderer = (props) => {
    const { record } = props;
    const parseDate = record.created_at
        ? (0, format_1.default)(new Date(record.created_at), (0, utilities_1.dateFormatBasedOnCountry)())
        : '';
    return (react_2.default.createElement(react_1.default, { content: parseDate, placement: "top", key: parseDate },
        react_2.default.createElement("span", { className: styles_modules_less_1.default['date-created-cell__body'] }, parseDate)));
};
exports.DateCreatedRenderer = DateCreatedRenderer;
const SourceRenderer = (props) => {
    var _a;
    const { asset } = (_a = props === null || props === void 0 ? void 0 : props.record) === null || _a === void 0 ? void 0 : _a.source;
    const { round_thumbnail_link } = props === null || props === void 0 ? void 0 : props.record;
    // default, we get asset, if we have website then get round thumbnail link or in progress if this round thumbnail link is not ready
    const src = `${helper_1.URLS.pulse}openpreview.php?format=thumb&assetid=`;
    if (asset) {
        return (react_2.default.createElement("img", { className: (asset === null || asset === void 0 ? void 0 : asset.has_preview)
                ? styles_modules_less_1.default['custom-review-img']
                : styles_modules_less_1.default['default-review-image'], src: (asset === null || asset === void 0 ? void 0 : asset.has_preview) ? `${src}${asset === null || asset === void 0 ? void 0 : asset.id}` : helper_1.defaultV3Image }));
    }
    return round_thumbnail_link ? (react_2.default.createElement("i", { className: (0, clsx_1.default)(styles_modules_less_1.default['url-thumbnail-icon'], 'fa-light fa-browser') })) : (react_2.default.createElement("img", { className: styles_modules_less_1.default['custom-review-img'], src: helper_1.defaultV3Image }));
};
exports.SourceRenderer = SourceRenderer;
const ViewButtonRenderer = (props) => {
    var _a, _b;
    const { setOpenReviewModal, openReviewModal } = (0, react_2.useContext)(ReviewModalContext_1.CreateReviewModalContext);
    const [openCancelModal, setOpenCancelModal] = (0, react_2.useState)(false);
    const [openEllipsisMenu, setOpenEllipsisMenu] = (0, react_2.useState)(false);
    const [menuPermission, setMenuPermission] = (0, react_2.useState)([]);
    const [openManageNotificationModal, setOpenManageNotificationModal] = (0, react_2.useState)(false);
    const [openViewLinkedTasks, setOpenViewLinkedTasks] = (0, react_2.useState)(false);
    const [isNoLinkedTasks, setIsNoLinkedTasks] = (0, react_2.useState)(true);
    const assetDetailInstance = (0, react_2.createRef)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { record, disableViewProofBtn, ticketId = 0, openMoveReviewModal, openPublicLinkModal, } = props;
    const { asset } = record === null || record === void 0 ? void 0 : record.source;
    const openViewProof = () => {
        window.open(`${helper_1.URLS.app}reviews/view-proof/${record.round_id}`, '_blank');
    };
    const handleCancelModal = () => {
        setOpenCancelModal(!openCancelModal);
        setOpenEllipsisMenu(false);
    };
    const handleOpenCreateNewModal = () => {
        dispatch((0, sliceReview_1.openModal)({
            status: constants_1.MODE.newRound,
            round: {
                ...record,
                source: [record.source],
                id: record.round_id,
            },
            ticketId,
        }));
        if (setOpenReviewModal) {
            setOpenReviewModal(!openReviewModal);
        }
        setOpenEllipsisMenu(false);
    };
    const handleOpenReviewSetting = () => {
        dispatch((0, sliceReview_1.openModal)({
            status: constants_1.MODE.update,
            round: {
                ...record,
                source: [record.source],
                id: record.round_id,
            },
        }));
        if (setOpenReviewModal) {
            setOpenReviewModal(!openReviewModal);
        }
        setOpenEllipsisMenu(false);
    };
    const handleOpenViewLinkedTasks = async () => {
        if (record.round_id) {
            utilities_1.default.blockPage();
            await pulse_components_1.v2Endpoint
                .get(`${helper_1.URLS.app}api/rounds/${record.round_id}/tickets`)
                .then((res) => {
                setIsNoLinkedTasks(!res.data.data.length);
                utilities_1.default.unblockPage();
            });
        }
        setOpenViewLinkedTasks(!openViewLinkedTasks);
        setOpenEllipsisMenu(false);
    };
    const handleOpenManageNotificationsModal = () => {
        setOpenManageNotificationModal(!openManageNotificationModal);
        setOpenEllipsisMenu(false);
    };
    const closeManageNotificationsModal = () => {
        setOpenManageNotificationModal(false);
    };
    const closeViewLinkedTasksModal = () => {
        setOpenViewLinkedTasks(false);
    };
    const handleOpenProjectPassport = () => {
        window.open(`${helper_1.URLS.app}passport/${record.job_id}`, '_blank');
    };
    const renderReviewDetail = (assetId, roundId) => {
        const reviewGridAssetDetailContainer = document.querySelector('#review-detail');
        const reviewGridAssetDetailRoot = reviewGridAssetDetailContainer &&
            (0, client_1.createRoot)(reviewGridAssetDetailContainer);
        if (setOpenReviewModal && reviewGridAssetDetailRoot) {
            reviewGridAssetDetailRoot.render(react_2.default.createElement(react_2.Suspense, { fallback: react_2.default.createElement("div", null, "Loading...") },
                react_2.default.createElement(PulseAssetDetail, { initialState: {
                        assetDetail: {
                            asset: {
                                assetId: asset === null || asset === void 0 ? void 0 : asset.id,
                            },
                            isZiflow: true,
                            isOpenDrawer: true,
                            isOpenHistory: false,
                            isAdvancedPanelCreated: false,
                            isOpenAdvanceDetails: false,
                            isOpenWorkFlowTabs: false,
                            isOpenAssetDetailsTabs: false,
                            isConfirmationModalVisible: false,
                        },
                        assetComments: {
                            comments: [],
                            versionComments: [],
                            ziflowActivities: [],
                        },
                        assetVersions: {
                            comments: [],
                        },
                        ticket: {
                            isUpdatingTicketProperty: [],
                            isUpdatingTicketField: [],
                        },
                        ticketHistory: {},
                        emailHistory: {
                            data: [],
                        },
                        review: {
                            reviewRound: null,
                            tasks: [],
                            isLoadingReviewRound: false,
                            setOpenReviewModal,
                        },
                    }, ticketId: ticketId, roundId: roundId, assetId: asset === null || asset === void 0 ? void 0 : asset.id, ref: assetDetailInstance, onClose: () => {
                        reviewGridAssetDetailRoot === null || reviewGridAssetDetailRoot === void 0 ? void 0 : reviewGridAssetDetailRoot.unmount();
                    } })));
        }
    };
    const handleOpenAssetDetail = () => {
        if (!assetDetailInstance) {
            return;
        }
        let roundId = record === null || record === void 0 ? void 0 : record.round_id;
        // use the deep links in the reviews tab
        if (CONTENT === 'passport-reviews' && (record === null || record === void 0 ? void 0 : record.round_id)) {
            window.location.hash = `${record === null || record === void 0 ? void 0 : record.review_id}-${record === null || record === void 0 ? void 0 : record.round_number}`;
            window.history.pushState({
                roundId: (record === null || record === void 0 ? void 0 : record.round_id) || 0,
            }, '');
            // round id deeplink will replace roundId from record, avoid duplicate fetching api review round
            roundId = 0;
        }
        setOpenEllipsisMenu(false);
        renderReviewDetail((asset === null || asset === void 0 ? void 0 : asset.id) || 0, roundId);
    };
    const handleUnlinkRoundToTask = async () => {
        await pulse_components_1.v2Endpoint
            .delete(`/v2/api/rounds/${record.round_id}/tickets/${ticketId}`)
            .then((res) => {
            utilities_1.default.notification.success('Unlink this round to the ticket successfully');
            const reloadGridEvent = new CustomEvent('reload-review-grid', {
                detail: {
                    status: 200,
                },
            });
            document.dispatchEvent(reloadGridEvent);
        })
            .catch(() => {
            utilities_1.default.notification.danger('Failed to unlink this round to ticket');
        });
    };
    const handleMoveReviewToAnotherProject = () => {
        if (record === null || record === void 0 ? void 0 : record.review_id) {
            openMoveReviewModal === null || openMoveReviewModal === void 0 ? void 0 : openMoveReviewModal(record === null || record === void 0 ? void 0 : record.review_id);
        }
    };
    const handlePublicLink = () => {
        openPublicLinkModal === null || openPublicLinkModal === void 0 ? void 0 : openPublicLinkModal();
    };
    const ELLIPSIS_ITEM_MANAGE_REVIEW = [
        {
            label: 'Open Review Detail',
            icon: true,
            iconClasses: {
                icon: 'fal fa-image',
            },
            onClick: handleOpenAssetDetail,
            asDropdownItem: true,
            variant: pulse_components_1.V3ButtonVariant.tertiary,
        },
        {
            label: 'Public Link',
            icon: true,
            iconClasses: {
                icon: 'fa-regular fa-link',
            },
            onClick: handlePublicLink,
            asDropdownItem: true,
            variant: pulse_components_1.V3ButtonVariant.tertiary,
        },
        {
            label: 'Review Settings',
            icon: true,
            iconClasses: {
                icon: 'fal fa-cog',
            },
            onClick: handleOpenReviewSetting,
            asDropdownItem: true,
            variant: pulse_components_1.V3ButtonVariant.tertiary,
        },
        {
            label: 'View Linked Tasks',
            icon: true,
            iconClasses: {
                icon: 'fal fa-link',
            },
            onClick: handleOpenViewLinkedTasks,
            asDropdownItem: true,
            variant: pulse_components_1.V3ButtonVariant.tertiary,
        },
        {
            label: 'New Review Round',
            icon: true,
            iconClasses: {
                icon: 'fal fa-plus-circle',
            },
            onClick: handleOpenCreateNewModal,
            asDropdownItem: true,
            variant: pulse_components_1.V3ButtonVariant.tertiary,
        },
        {
            label: 'Cancel Round',
            icon: true,
            iconClasses: {
                icon: 'fal fa-times-circle',
            },
            onClick: handleCancelModal,
            asDropdownItem: true,
            variant: pulse_components_1.V3ButtonVariant.tertiary,
        },
        {
            label: 'Notify Reviewers',
            icon: true,
            iconClasses: {
                icon: 'fal fa-envelope',
            },
            onClick: handleOpenManageNotificationsModal,
            asDropdownItem: true,
            variant: pulse_components_1.V3ButtonVariant.tertiary,
        },
        {
            label: 'Go To Project',
            icon: true,
            iconClasses: {
                icon: 'fal fa-rocket',
            },
            onClick: handleOpenProjectPassport,
            asDropdownItem: true,
            variant: pulse_components_1.V3ButtonVariant.tertiary,
        },
    ];
    const ELLIPSIS_ITEM_NO_PERMISSION = [
        {
            label: 'Open Review Detail',
            icon: true,
            iconClasses: {
                icon: 'fal fa-image',
            },
            onClick: handleOpenAssetDetail,
            asDropdownItem: true,
            variant: pulse_components_1.V3ButtonVariant.tertiary,
        },
        {
            label: 'Go To Project',
            icon: true,
            iconClasses: {
                icon: 'fal fa-rocket',
            },
            onClick: handleOpenProjectPassport,
            asDropdownItem: true,
            variant: pulse_components_1.V3ButtonVariant.tertiary,
        },
    ];
    (0, react_2.useEffect)(() => {
        const menuButtonOptions = IS_VIEW_REVIEW
            ? ELLIPSIS_ITEM_MANAGE_REVIEW
            : ELLIPSIS_ITEM_NO_PERMISSION;
        menuButtonOptions.push({
            label: 'Move Review',
            icon: true,
            iconClasses: {
                icon: 'fal fa-arrow-turn-down-right',
            },
            asDropdownItem: true,
            variant: pulse_components_1.V3ButtonVariant.tertiary,
            onClick: handleMoveReviewToAnotherProject,
        });
        if (ticketId) {
            menuButtonOptions.push({
                label: 'Unlink From Task',
                icon: true,
                iconClasses: {
                    icon: 'fal fa-unlink',
                    asDropdownItem: true,
                    variant: pulse_components_1.V3ButtonVariant.tertiary,
                },
                onClick: handleUnlinkRoundToTask,
            });
        }
        const menu = menuButtonOptions.filter((menuButton) => {
            const hasManagePermission = IS_REVIEW_ADMIN ||
                (IS_VIEW_REVIEW && (record === null || record === void 0 ? void 0 : record.manage)) ||
                `${record === null || record === void 0 ? void 0 : record.owner_id}` === `${utilities_1.USER.id}`;
            return hasManagePermission
                ? true
                : !helper_1.DISABLED_PERMISSIONS_LABELS.includes(menuButton.label);
        });
        setMenuPermission(menu);
    }, []);
    return (react_2.default.createElement("div", { className: (0, clsx_1.default)(styles_modules_less_1.default.groupButton) },
        react_2.default.createElement(pulse_components_1.PulseButtonV3, { icon: true, iconClasses: {
                icon: (0, clsx_1.default)({
                    'fa-solid fa-circle-o-notch fa-spin': disableViewProofBtn,
                    'fa-solid fa-up-right-from-square': !disableViewProofBtn,
                    [styles_modules_less_1.default['view-proof-btn__icon']]: true,
                }),
            }, label: disableViewProofBtn ? 'Preparing...' : 'View proof', onClick: openViewProof, disabled: disableViewProofBtn, variant: pulse_components_1.V3ButtonVariant.tertiary, "data-action": "view-proof" }),
        react_2.default.createElement(pulse_components_1.PulseMenuButton, { classes: {
                root: (0, clsx_1.default)(styles_modules_less_1.default['action-menu-button__root']),
                menuCtn: styles_modules_less_1.default['dropdown-button__ctn'],
            }, designVariant: "v3", MenuV3ButtonProps: openEllipsisMenu ? menuPermission : [], PulseV3ButtonProps: {
                label: '',
                icon: true,
                iconClasses: {
                    icon: (0, clsx_1.default)('fa-solid fa-ellipsis-vertical', styles_modules_less_1.default['action-menu-button__icon']),
                },
                'data-action': 'view-menu',
                onClick: () => {
                    setOpenEllipsisMenu(true);
                },
                variant: pulse_components_1.V3ButtonVariant.tertiary,
            }, TippyProps: {
                trigger: 'click',
                placement: 'bottom-start',
                appendTo: document.body,
                offset: [0, 5],
                arrow: false,
            } }),
        openViewLinkedTasks && (react_2.default.createElement(ViewLinkedTasksModal_1.default, { isNoLinkedTasks: isNoLinkedTasks, isOpen: openViewLinkedTasks, handleCloseModal: closeViewLinkedTasksModal, roundId: Number(record.round_id) })),
        openCancelModal && (react_2.default.createElement(CancelReviewModal_1.default, { isOpen: openCancelModal, handleClose: handleCancelModal, round: {
                id: record.round_id || 0,
                title: record.round_title || '',
            } })),
        openManageNotificationModal && (react_2.default.createElement(react_2.Suspense, { fallback: react_2.default.createElement("div", null, "Loading...") },
            react_2.default.createElement(ManageNotificationsModal, { open: openManageNotificationModal, onModalClose: closeManageNotificationsModal, jobId: record === null || record === void 0 ? void 0 : record.job_id, assetId: (_b = (_a = record === null || record === void 0 ? void 0 : record.source) === null || _a === void 0 ? void 0 : _a.asset) === null || _b === void 0 ? void 0 : _b.id, roundId: record === null || record === void 0 ? void 0 : record.round_id })))));
};
const ViewBtnRenderer = (0, withMoveReviewModal_1.default)((0, withPublicLinkModal_1.default)(ViewButtonRenderer));
exports.ViewBtnRenderer = ViewBtnRenderer;
